import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import * as imageMapResizer from 'image-map-resizer';
import { Observable } from 'rxjs';
import { ShopService } from '../shop.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-market',
  templateUrl: './market.component.html',
  styleUrls: ['./market.component.scss']
})
export class MarketComponent implements OnInit {
  activities: any;
  stands$: Observable<any[]>;
  _market: string;

  get market(): string { return this._market; }

  @Input() set market(value: string) {
    this._market = value;
    this._refreshData();
  }

  constructor(private route: ActivatedRoute, private shopService: ShopService, public dialog: MatDialog) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.market = params['id'];
    });
  }

  _refreshData() {
    this.shopService.getMarketActivities().toPromise().then(activities => {
      console.log(activities);
      this.activities = activities;
    });

    this.stands$ = this.shopService.getMarket(this.market);
  }

  resizePlanMapArea() {
    imageMapResizer();
  }

  trackByStandId(index: number, stand: any): string {
    return stand.id;
  }

  async displayStandDialog(standIdPlan: string) {
    const stands = (await this.stands$.toPromise());
    const dialogRef = this.dialog.open(MarketStandDialog, {
      // width: '250px',
      data: stands.find((item) => item.idPlan === standIdPlan)
    });

    // dialogRef.afterClosed().subscribe(result => {
    //   console.log('The dialog was closed');
    //   this.animal = result;
    // });
  }
}

@Component({
  selector: 'market-stand-dialog',
  templateUrl: 'market-stand-dialog.html',
  styleUrls: ['./market.component.scss']
})
export class MarketStandDialog {
  constructor(
    public dialogRef: MatDialogRef<MarketStandDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  onNoClick(): void {
    this.dialogRef.close();
  }
}